<template>
  <el-form ref="form" :model="form" label-width="200px" :rules="rules" class="demo-ruleForm">
    <el-form-item :label="$t('email.Email.9398975-0')" prop="zhanghao">
      <el-input v-model="form.zhanghao" :placeholder="$t('email.Email.9398975-1')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('email.Email.9398975-2')" prop="shouquanma">
      <el-input v-model="form.shouquanma" :placeholder="$t('email.Email.9398975-3')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('email.Email.9398975-4')" prop="fuwuqi">
      <el-input v-model="form.fuwuqi" :placeholder="$t('email.Email.9398975-5')" :validate-event="false"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm('form')">{{ $t("email.Email.9398975-6") }}</el-button>
      <el-button @click="resetForm('form')">{{ $t("email.Email.9398975-7") }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          zhanghao: "",
          shouquanma: "",
          fuwuqi: ""
        },
        rules: {
          zhanghao: [
            { required: true, message: this.$t("email.Email.9398975-8"), trigger: "blur" },
            { type: "email", message: this.$t("email.Email.9398975-9"), trigger: ["blur", "change"] }
          ],
          shouquanma: [{ required: true, message: this.$t("email.Email.9398975-10"), trigger: "blur" }],
          fuwuqi: [{ required: true, message: this.$t("email.Email.9398975-11"), trigger: "blur" }]
        }
      };
    },
    methods: {
      submitForm(form) {
        this.$refs[form].validate(valid => {
          this.$refs[form].validate(valid => {
            if (valid) {
              this.$api
                .request(this.$url.Email.save, this.$method.post, this.form)
                .then(res => {
                  if (res.code === 0) {
                    this.$notify({
                      title: this.$t("email.Email.9398975-12"),
                      message: res.msg,
                      type: "success"
                    });
                  }
                })
                .catch(err => {
                  this.$notify({
                    title: this.$t("email.Email.9398975-13"),
                    message: err.msg,
                    type: "error"
                  });
                });
            }
          });
        });
      },
      resetForm(form) {
        this.$refs[form].resetFields();
      }
    }
  };
</script>

<style scoped lang="scss">
  .el-input {
    width: 40%;
  }
  .el-form {
    form {
      width: 90%;
      margin: auto;
      border: 0.01rem solid gray;
      display: flex;
      flex-wrap: wrap;
      input {
        width: 80%;
        height: 0.5rem;
        margin-bottom: 0.2rem;
        border: 0.01rem solid black;
        height: 0.5rem;
      }
    }
    .but {
      font-size: 0.14rem;
      margin-left: 5%;
    }
  }
</style>
